import Image from 'next/image'
import { Dropdown } from 'rsuite'
import { useRouter } from 'next/router'
import { CustomNavHeader } from './headerElements'

const LOGO_ROUTES = '/logos'

const BrandLogo = ({ brand, onClick, href = '#' }) => {
  const Wrapper = onClick
    ? ({ children }) => (
        <div onClick={onClick} href={href}>
          {children}
        </div>
      )
    : ({ children }) => <>{children}</>
  return (
    <Wrapper>
      <Image
        src={`${LOGO_ROUTES}/${brand.toLowerCase()}.png`}
        alt={`${brand} logo`}
        height={36}
        width={50}
        title={`${brand} logo`}
      />
    </Wrapper>
  )
}

function HeaderBrand({ brands, filterBy, isOnline, showStaticLogo, onBrandChange }) {
  const router = useRouter()
  const returnToLandingPage = e => {
    e.preventDefault()
    isOnline ? router.push('/').catch(console.error) : router.replace('/cachedPublications')
  }

  const isDefaultBrand = brands.length === 0 || !filterBy.brand || !isOnline
  const isBrandSelected = brands.length > 0 && showStaticLogo && filterBy.brand
  const canSelectBrands = !showStaticLogo && brands.length > 0 && filterBy.brand && isOnline

  return (
    <CustomNavHeader>
      {isDefaultBrand && <BrandLogo brand="toyota" onClick={returnToLandingPage} />}
      {isBrandSelected && <BrandLogo brand={filterBy.brand} onClick={returnToLandingPage} />}
      {canSelectBrands && (
        <Dropdown
          icon={<BrandLogo brand={filterBy.brand} />}
          placement="bottomStart"
          activeKey={filterBy.brand}
          onSelect={onBrandChange}
          menuStyle={{ width: 190 }}
        >
          {brands.map(brand => (
            <Dropdown.Item
              key={brand}
              eventKey={brand}
              active={brand === filterBy.brand}
              icon={<BrandLogo brand={brand} />}
            />
          ))}
        </Dropdown>
      )}
    </CustomNavHeader>
  )
}

export default HeaderBrand
